/**
 * BILL-05: the backend writes two machine sentinels into
 * `Recording.failureReason` (internal/recordings orchestrator):
 *
 *  - `credits_exhausted` — the audio ran past the cap the user's balance could
 *    pay for. Shown with an "Add credits" link to /billing.
 *  - `duration_exceeds_declared` — the audio ran past the cap sized from the
 *    client's `duration_secs` hint. A retry sends no hint, so it is re-sized
 *    from the balance; no top-up is implied.
 *
 * Every other reason is free text from the worker and renders verbatim.
 */

const FAILURE_CREDITS_EXHAUSTED = 'credits_exhausted';
const FAILURE_DURATION_EXCEEDS_DECLARED = 'duration_exceeds_declared';

export interface FailureReasonLabel {
  text: string;
  /** Render the "Add credits" (/billing) link beside the reason. */
  topUp: boolean;
}

/**
 * `t` is a `recordings`-namespaced translator (`useTranslations('recordings')`).
 * Returns null for an empty reason so callers keep their own fallback copy.
 */
export function failureReasonLabel(reason: string, t: (key: string) => string): FailureReasonLabel | null {
  if (!reason) return null;
  if (reason === FAILURE_CREDITS_EXHAUSTED) return { text: t('failure.creditsExhausted'), topUp: true };
  if (reason === FAILURE_DURATION_EXCEEDS_DECLARED) {
    return { text: t('failure.declaredLengthExceeded'), topUp: false };
  }
  return { text: reason, topUp: false };
}
